import { useState, useRef } from "react";
import styled from "styled-components";
import Flex from "../flex";
import Box from "../box";
import Dropdown from "../dropdown";
import Menu from "../menu";
import Input from "../input";
import Empty from "../empty";
import { CrownOutlined } from "../../icons";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AdminOnly = styled(CrownOutlined).withConfig({
  displayName: "filter-dropdown__AdminOnly",
  componentId: "sc-1ocnqi9-0"
})(["&,&.anticon:first-child{min-width:auto;margin-right:4px;color:", ";}"], p => p.theme.colors.secondary.base);
function FilterDropdown(_ref) {
  let {
    options,
    showSearch,
    onClick,
    className,
    children
  } = _ref;
  const [query, setQuery] = useState("");
  const inputRef = useRef(null);
  const matchesQuery = text => String(text).toLowerCase().includes(query.trim().toLowerCase());
  const onVisibleChange = visible => {
    if (visible && showSearch) {
      setQuery("");
      setTimeout(() => inputRef.current?.focus(), 100);
    }
  };
  const visibleOptions = options.filter(opt => !showSearch || matchesQuery(opt.label));
  const menu = /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    bg: "popover.bg",
    borderRadius: "base",
    boxShadow: "base",
    overflow: "hidden",
    children: [showSearch && /*#__PURE__*/_jsx(Box, {
      m: 2,
      mb: 1,
      onClick: e => e.stopPropagation(),
      children: /*#__PURE__*/_jsx(Input, {
        size: "small",
        placeholder: "Search",
        ref: inputRef,
        value: query,
        onChange: e => setQuery(e.target.value),
        allowClear: true
      })
    }), /*#__PURE__*/_jsxs(Box, {
      my: 1,
      maxHeight: 260,
      overflowY: "scroll",
      children: [/*#__PURE__*/_jsx(Menu, {
        prefixCls: "ant-dropdown-menu",
        selectable: false,
        onClick: onClick,
        style: {
          padding: 0,
          boxShadow: "none"
        },
        children: visibleOptions.map(opt => /*#__PURE__*/_jsxs(Menu.Item, {
          disabled: opt.disabled,
          children: [opt.adminOnly && /*#__PURE__*/_jsx(AdminOnly, {}), opt.label]
        }, opt.dataIndex))
      }), query && visibleOptions.length === 0 && /*#__PURE__*/_jsx(Empty, {
        image: Empty.PRESENTED_IMAGE_SIMPLE
      })]
    })]
  });
  return /*#__PURE__*/_jsx(Dropdown, {
    className: className,
    overlay: menu,
    trigger: ["click"],
    onVisibleChange: onVisibleChange,
    forceRender: true,
    children: children
  });
}
export default FilterDropdown;